import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import config from "../../config";
import Footer from "./Footer";
import Header from "./Header";
import Papa from "papaparse";
import { useNetworkState } from "react-use";
import Moment from "react-moment";
import ReactLoading from "react-loading";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";

const Create_order = () => {
  const navigate = useNavigate();
  const userDetail = localStorage.getItem("ship_rocket_user");
  let userData = {};
  if (userDetail) userData = JSON.parse(userDetail);

  // ─── TOAST ───────────────────────────────────────────────────────
  const Toast = Swal.mixin({
    toast: true,
    position: "bottom-end",
    showConfirmButton: false,
    timer: 3000,
  });

  // ─── TAB STATE ──────────────────────────────────────────────────
  const [activeTab, setActiveTab] = useState("single"); // "single" or "bulk"
  const [searchParams, setSearchParams] = useSearchParams();
  const [orderView, setOrderView] = useState(
    searchParams.get("view") === "bulk" ? "bulk" : "single"
  );
  // ─── ADDRESS BOOK (Pickup) ─────────────────────────────────────
  const [addressList, setAddressList] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [loadingAddress, setLoadingAddress] = useState(true);

  // ─── BUYER / RECEIVER ──────────────────────────────────────────
  const [receiver, setReceiver] = useState({
    receiver_name: "",
    receiver_email: "",
    receiver_mobile: "",
    receiver_address: "",
    receiver_country: "",
    receiver_country_code: "",
    receiver_postal_code: "",
    receiver_city: "",
    receiver_state_name: "",
    receiver_city_id: "",
    receiver_state_id: "",
    mode: "Domestic",
    moving_type: "Forward",
  });

  // ─── COUNTRY / STATE / CITY / PINCODE ─────────────────────────
  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [pincodeList, setPincodeList] = useState([]);
  const [selectedCountryId, setSelectedCountryId] = useState("");
  const [pincodeInput, setPincodeInput] = useState("");
  const [autoState, setAutoState] = useState("");
  const [autoCity, setAutoCity] = useState("");
  const [autoStateId, setAutoStateId] = useState("");
  const [autoCityId, setAutoCityId] = useState("");

  // ─── ORDER DETAILS ─────────────────────────────────────────────
  const [orderDetails, setOrderDetails] = useState({
    order_id: "",
    order_date: "",
    parcel_type: "Parcel",
    payment_mode: "prepaid",
    cod_amount: "",
  });

  // ─── PRODUCTS ───────────────────────────────────────────────────
  const [products, setProducts] = useState([
    {
      item_sku: "",
      shipment_content: "",
      total_value: "",
      quantity: 1,
      error: {},
    },
  ]);

  // ─── PACKAGE / WEIGHT ──────────────────────────────────────────
  const [packageData, setPackageData] = useState({
    dead_weight: "",
    height: "",
    width: "",
    length: "",
  });
  const [volumetricStatus, setVolumetricStatus] = useState(null);
  const [volumetricWeight, setVolumetricWeight] = useState(0);

  // ─── SUBMIT STATE ──────────────────────────────────────────────
  const [submitting, setSubmitting] = useState(false);
  const [recordid, setRecordid] = React.useState({ record_id: "" });
  const [uploadModalState, setUploadModalState] = React.useState({
    show: false,
    excel_fle: "",
  });
  const [dimensionState, setdimensionState] = React.useState({
    companyDetail: [],
  });
  const [loadingstate, setLoadingstate] = React.useState(false);
  const [summarystate, setSummarystate] = React.useState(false);
  const [statesummary, setsummaryState] = React.useState([]);
  const [summaryloader, setSummaryLoader] = React.useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);
  const [loader, setloader] = React.useState(false);
  const [dataloader, setdataloader] = React.useState(true);
  const [csvFileError, setCsvFileError] = React.useState([]);

  // ─── GENERATE ORDER NUMBER ─────────────────────────────────────
  const generateOrderNumber = useCallback(() => {
    const random = Math.floor(Math.random() * 1000000);
    const num = `ORD${random}`;
    const now = new Date();
    const y = now.getFullYear();
    const m = String(now.getMonth() + 1).padStart(2, "0");
    const d = String(now.getDate()).padStart(2, "0");
    setOrderDetails((prev) => ({
      ...prev,
      order_id: num,
      order_date: `${y}-${m}-${d}`,
    }));
  }, []);

  // ─── FETCH VOLUMETRIC STATUS ──────────────────────────────────
  const fetchVolumetricStatus = useCallback(async () => {
    try {
      const url = config.apiUrl + "/user/customer_volumetric_status";
      const res = await axios.post(url, {}, { headers: config.headers });
      setVolumetricStatus(res.data.volumetric_status);
    } catch (_) {
      setVolumetricStatus(1);
    }
  }, []);

  // ─── FETCH ADDRESS BOOK ────────────────────────────────────────
  const fetchAddressBook = useCallback(async () => {
    try {
      const url = config.apiUrl + "/country/address_book";
      const sendData = { customer_id: userData.customer_id };
      const res = await axios.post(url, sendData, { headers: config.headers });
      if (res.data.status) {
        const addresses = res.data.output || [];
        setAddressList(addresses);
        if (addresses.length > 0) setSelectedAddress(0);
      }
      setLoadingAddress(false);
    } catch (_) {
      setLoadingAddress(false);
      Toast.fire({
        background: "#a61c09",
        title: "Could not load pickup addresses",
        color: "white",
      });
    }
  }, [userData.customer_id]);

  // ─── FETCH COUNTRY LIST ────────────────────────────────────────
  const fetchCountries = useCallback(async () => {
    try {
      const url = config.apiUrl + "/country/country_list_international";
      const res = await axios.post(
        url,
        { limit: 300, status: 1 },
        { headers: config.headers }
      );
      setCountryList(res.data.output || []);
    } catch (_) {}
  }, []);

  // ─── FETCH STATE LIST ──────────────────────────────────────────
  const fetchStates = useCallback(async (countryId) => {
    if (!countryId) return;
    try {
      const url = config.apiUrl + "/country/state_list";
      const res = await axios.post(
        url,
        { t_country_id: countryId, limit: 1000 },
        { headers: config.headers }
      );
      setStateList(res.data.output || []);
    } catch (_) {}
  }, []);

  // ─── FETCH CITY LIST ───────────────────────────────────────────
  const fetchCities = useCallback(async (stateId, countryId) => {
    if (!stateId || !countryId) return;
    try {
      const url = config.apiUrl + "/country/city_list";
      const res = await axios.post(
        url,
        { state_id: stateId, country_id: countryId, limit: 1000 },
        { headers: config.headers }
      );
      setCityList(res.data.output || []);
    } catch (_) {}
  }, []);

  // ─── FETCH PINCODE LIST ────────────────────────────────────────
  const fetchPincodes = useCallback(async (cityId) => {
    if (!cityId) return;
    try {
      const url = config.apiUrl + "/country/pincode_list";
      const res = await axios.post(
        url,
        { city_id: cityId },
        { headers: config.headers }
      );
      setPincodeList(res.data.output || []);
    } catch (_) {}
  }, []);

  // ─── AUTO-FILL STATE/CITY FROM PINCODE ────────────────────────
  const fetchPincodeDetails = useCallback(
    async (pincode) => {
      if (!pincode || pincode.length < 3) {
        setAutoState("");
        setAutoCity("");
        setAutoStateId("");
        setAutoCityId("");
        return;
      }
      try {
        const url = config.apiUrl + "/country/automate_pincode";
        const res = await axios.post(
          url,
          { enteredPincode: pincode, country_id: selectedCountryId || 1 },
          { headers: config.headers }
        );
        const { state, city, state_id, city_id } = res.data;
        setAutoState(state || "");
        setAutoCity(city || "");
        setAutoStateId(state_id || "");
        setAutoCityId(city_id || "");
      } catch (_) {
        setAutoState("");
        setAutoCity("");
        setAutoStateId("");
        setAutoCityId("");
      }
    },
    [selectedCountryId]
  );

  // ─── HANDLE PINCODE INPUT ──────────────────────────────────────
  const handlePincodeChange = (e) => {
    const val = e.target.value;
    setPincodeInput(val);
    fetchPincodeDetails(val);
  };

  // ─── SELECT COUNTRY ────────────────────────────────────────────
  const handleCountryChange = (e) => {
    const val = e.target.value;
    const [id, name, code] = val.split(",");
    setSelectedCountryId(id);
    setReceiver((prev) => ({
      ...prev,
      receiver_country: name || "",
      receiver_country_code: code || "",
    }));
    setStateList([]);
    setCityList([]);
    setPincodeList([]);
    setAutoState("");
    setAutoCity("");
    setAutoStateId("");
    setAutoCityId("");
    if (id) fetchStates(id);
  };

  // ─── SELECT STATE ──────────────────────────────────────────────
  const handleStateChange = (e) => {
    const val = e.target.value;
    const [stateId, countryId] = val.split(",");
    setReceiver((prev) => ({
      ...prev,
      receiver_state_id: stateId,
      receiver_state_name: e.target.options[e.target.selectedIndex]?.text || "",
    }));
    setCityList([]);
    setPincodeList([]);
    setAutoCity("");
    setAutoCityId("");
    if (stateId && countryId) fetchCities(stateId, countryId);
  };

  // ─── SELECT CITY ───────────────────────────────────────────────
  const handleCityChange = (e) => {
    const val = e.target.value;
    const [cityId, cityName] = [
      val,
      e.target.options[e.target.selectedIndex]?.text || "",
    ];
    setReceiver((prev) => ({
      ...prev,
      receiver_city_id: cityId,
      receiver_city: cityName,
    }));
    setPincodeList([]);
    if (cityId) fetchPincodes(cityId);
  };

  // ─── SELECT PINCODE ────────────────────────────────────────────
  const handlePincodeSelect = (e) => {
    const val = e.target.value;
    setReceiver((prev) => ({ ...prev, receiver_postal_code: val }));
  };

  // ─── SELECT ADDRESS FROM BOOK ──────────────────────────────────
  const selectAddress = (index) => {
    setSelectedAddress(index);
  };

  // ─── ADD / REMOVE PRODUCT ROWS ─────────────────────────────────
  const addProductRow = () => {
    setProducts((prev) => [
      ...prev,
      {
        item_sku: "",
        shipment_content: "",
        total_value: "",
        quantity: 1,
        error: {},
      },
    ]);
  };

  const removeProductRow = (index) => {
    if (products.length <= 1) return;
    setProducts((prev) => prev.filter((_, i) => i !== index));
  };

  const updateProduct = (index, field, value) => {
    setProducts((prev) => {
      const updated = [...prev];
      updated[index][field] = value;
      if (field !== "error") {
        updated[index].error = { ...updated[index].error, [field]: false };
      }
      return updated;
    });
  };

  // ─── CALCULATE TOTAL ORDER VALUE ──────────────────────────────
  const calculateTotal = () => {
    return products.reduce((acc, p) => {
      const val = parseFloat(p.total_value) || 0;
      const qty = parseInt(p.quantity) || 0;
      return acc + val * qty;
    }, 0);
  };

  // ─── VOLUMETRIC WEIGHT CALC ────────────────────────────────────
  useEffect(() => {
    const { height, width, length } = packageData;
    if (height && width && length && volumetricStatus) {
      const divisor = volumetricStatus === 1 ? 5000 : 1;
      const vol =
        (parseFloat(height) * parseFloat(width) * parseFloat(length)) / divisor;
      setVolumetricWeight(parseFloat(vol.toFixed(2)));
    } else {
      setVolumetricWeight(0);
    }
  }, [
    packageData.height,
    packageData.width,
    packageData.length,
    volumetricStatus,
  ]);

  // ─── APPLICABLE WEIGHT ─────────────────────────────────────────
  const applicableWeight = () => {
    const dead = parseFloat(packageData.dead_weight) || 0;
    const vol = parseFloat(volumetricWeight) || 0;
    if (dead === 0 && vol === 0) return 0;
    return Math.max(dead, vol);
  };

  // ─── INIT ──────────────────────────────────────────────────────
  useEffect(() => {
    generateOrderNumber();
    fetchAddressBook();
    fetchCountries();
    fetchVolumetricStatus();
  }, []);

  // ─── VALIDATION ─────────────────────────────────────────────────
  const validate = () => {
    let valid = true;

    // Receiver
    if (!receiver.receiver_name.trim()) valid = false;
    if (
      !receiver.receiver_mobile.trim() ||
      receiver.receiver_mobile.length !== 10
    )
      valid = false;
    if (
      receiver.receiver_email.trim() &&
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(receiver.receiver_email.trim())
    )
      valid = false;
    if (!receiver.receiver_address.trim()) valid = false;
    if (receiver.mode === "Domestic") {
      if (!pincodeInput || pincodeInput.length < 3) valid = false;
      if (!autoState) valid = false;
      if (!autoCity) valid = false;
    } else {
      if (!receiver.receiver_country) valid = false;
    }

    // Address book
    if (selectedAddress === null && addressList.length === 0) valid = false;

    // Products
    products.forEach((p) => {
      if (!p.shipment_content.trim()) valid = false;
      if (!p.total_value || parseFloat(p.total_value) <= 0) valid = false;
      if (!p.quantity || parseInt(p.quantity) <= 0) valid = false;
    });

    // Package
    if (!packageData.dead_weight || parseFloat(packageData.dead_weight) <= 0)
      valid = false;
    if (!packageData.height || parseFloat(packageData.height) <= 0)
      valid = false;
    if (!packageData.width || parseFloat(packageData.width) <= 0) valid = false;
    if (!packageData.length || parseFloat(packageData.length) <= 0)
      valid = false;

    // COD
    if (
      orderDetails.payment_mode === "cod" &&
      (!orderDetails.cod_amount || parseFloat(orderDetails.cod_amount) <= 0)
    )
      valid = false;

    return valid;
  };

  // ─── SUBMIT ORDER ──────────────────────────────────────────────
  const handleSubmit = async () => {
    if (submitting) return;

    if (!validate()) {
      Toast.fire({
        background: "#a61c09",
        title: "Please fill all required fields correctly",
        color: "white",
      });
      return;
    }

    setSubmitting(true);

    const selectedAddr = addressList[selectedAddress] || {};

    const shipmentItems = products.map((p) => ({
      item_name: p.shipment_content,
      item_value: p.total_value,
      quantity: p.quantity,
      item_sku: p.item_sku || "",
    }));

    const dataToSend = {
      customer_id: userData.customer_id,
      sender_name: selectedAddr.full_name || userData.full_name || "",
      sender_mobile: selectedAddr.mobile || "",
      sender_email: selectedAddr.email || "",
      sender_address: selectedAddr.address || "",
      sender_city: selectedAddr.city_name || "",
      sender_city_id: selectedAddr.city_id || "",
      sender_country_name: selectedAddr.country_name || "",
      sender_country_code: selectedAddr.country_code || "",
      sender_postal_code: selectedAddr.pincode || "",
      sender_state_name: selectedAddr.state_name || "",

      receiver_name: receiver.receiver_name,
      receiver_mobile: receiver.receiver_mobile,
      receiver_email: receiver.receiver_email || "",
      receiver_address: receiver.receiver_address,
      receiver_city:
        receiver.mode === "Domestic" ? autoCity : receiver.receiver_city,
      receiver_city_id:
        receiver.mode === "Domestic" ? autoCityId : receiver.receiver_city_id,
      receiver_country_name:
        receiver.mode === "Domestic"
          ? receiver.receiver_country
          : receiver.receiver_country,
      receiver_country_code:
        receiver.mode === "Domestic"
          ? receiver.receiver_country_code
          : receiver.receiver_country_code,
      receiver_postal_code:
        receiver.mode === "Domestic"
          ? pincodeInput
          : receiver.receiver_postal_code,
      receiver_state_id:
        receiver.mode === "Domestic" ? autoStateId : receiver.receiver_state_id,
      receiver_state_name:
        receiver.mode === "Domestic" ? autoState : receiver.receiver_state_name,

      return_name: selectedAddr.full_name || userData.full_name || "",
      return_mobile: selectedAddr.mobile || "",
      return_email: selectedAddr.email || "",
      return_address: selectedAddr.address || "",
      return_city: selectedAddr.city_name || "",
      return_state_name: selectedAddr.state_name || "",
      return_country_name: selectedAddr.country_name || "",
      return_country_code: selectedAddr.country_code || "",
      return_postal_code: selectedAddr.pincode || "",

      payment_mode: orderDetails.payment_mode,
      shipment_type: orderDetails.parcel_type,
      cod_amount:
        orderDetails.payment_mode === "cod" ? orderDetails.cod_amount : "0",
      order_id: orderDetails.order_id,
      order_date: orderDetails.order_date,
      mode: receiver.mode,
      moving_type: receiver.moving_type,
      carrier_type: 1,
      order_type: 1,

      dead_weight: packageData.dead_weight,
      height: packageData.height,
      width: packageData.width,
      length: packageData.length,
      volumetric_weight: volumetricWeight,
      total_weight: applicableWeight(),

      item_name: shipmentItems.map((i) => i.item_name),
      item_value: shipmentItems.map((i) => i.item_value),
      quantity: shipmentItems.map((i) => i.quantity),
      item_sku: shipmentItems.map((i) => i.item_sku),

      address_id: selectedAddr.address_id || "",
      insurance_amount: 0,
      type: orderDetails.parcel_type,
    };

    try {
      const url = config.apiUrl + "/shipment/order_create";
      const response = await axios.post(url, dataToSend, {
        headers: config.headers,
      });

      if (response.data.status) {
        Swal.fire({
          toast: true,
          position: "bottom-end",
          icon: "success",
          title: "Order created successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        if (receiver.mode === "Domestic") {
          window.location.replace(
            `/orders?moving=${receiver.moving_type === "Forward" ? 1 : 2}`
          );
        } else {
          window.location.replace("/international_orders");
        }
      } else {
        Toast.fire({
          background: "#a61c09",
          title: response.data?.message || "Something went wrong.",
          color: "white",
        });
      }
    } catch (err) {
      Toast.fire({
        background: "#a61c09",
        title: "Server error. Please try again.",
        color: "white",
      });
    } finally {
      setSubmitting(false);
    }
  };

  React.useEffect(() => {
    shipment_list();
    dimension_detail();
  }, []);

  const shipment_list = (status) => {
    setdataloader(true);
    let dataToSend = {
      customer_id: userData.customer_id,
      status: status,
    };

    // console.log("datatoSend",dataToSend)
    let url = config.apiUrl + "/shipment/view_order_file_summary";

    // // console.log("headers => ", config.headers);

    axios
      .post(url, dataToSend, { headers: config.headers })
      .then((res) => {
        // console.log("responseJson => ", res);
        // setSummarystate(res.data.output)
        setsummaryState(res.data.output);
        setdataloader(false);
      })
      .catch((error) => {
        setdataloader(false);
        //Hide Loader
        //   setLoadingstate({...loadingstate,loading:false})
        // console.log(error);
      });
  };
  const dimension_detail = () => {
    let full_api = config.apiUrl + `/user/get_company_info_api`;
    let sendData = {};

    axios
      .post(full_api, sendData, { headers: config.headers })
      .then((res) => {
        setdimensionState({
          ...dimensionState,
          companyDetail: res.data.companyDetail,
        });
        // console.log("rnmmmmm", res);
      })
      .catch((e) => {
        // toast.configure()
        //toast.error("Some thing went wrong")
        // console.log("----error:   ", e);
      });
  };
  const csvinputEditHandleChange = (e) => {
    // console.log(e.target.files[0].type);
    if (e.target.type == "file") {
      setCsvFileError([]);
      if (e.target.files.length > 0) {
        // setUploadModalState({ ...uploadModalState, [e.target.name]: e.target.files });
        if (e.target.files[0].type == "text/csv") {
          setloader(true);
          Papa.parse(e.target.files[0], {
            header: true,
            skipEmptyLines: true,
            complete: function (results) {
              // console.log("re => ", results.data)

              checkCsvFile(results.data, e.target.files);
            },
          });
        } else {
          const Toast = Swal.mixin({
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 3000,
          });
          Toast.fire({
            background: "#ff0000",
            type: "error",
            title: "Please select CSV file only",
            color: "white",
          });
        }
      }
    } else {
      setUploadModalState({
        ...uploadModalState,
        [e.target.name]: e.target.value,
      });
    }
  };

  const checkCsvFile = (data, file) => {
    const pincodeLength = 6;
    const mobileLength = 10;
    const keyFields = [
      "Order_ID",
      "Warehouse_Name",
      "Receiver_Name",
      "Receiver_Address",
      "Receiver_Pincode",
      "Receiver_Email",
      "Receiver_Mobile",
      "Item_Name",
      "Height",
      "Width",
      "Length",
      "Weight (KG)",
      "Item_Value",
      "Item_Quantity",
      "Payment_Mode",
      "COD_Value",
    ];

    const csvError = [];
    let validFile = true;

    data.forEach((item, index) => {
      const rowError = Array(keyFields.length).fill(""); // Initialize row error array
      let isValid = true;

      // Check for missing fields
      const missingFields = keyFields.filter((field) => !(field in item));
      if (missingFields.length > 0) {
        missingFields.forEach((field) => {
          const colIndex = keyFields.indexOf(field);
          rowError[colIndex] = "MISSING FIELD";
        });
        isValid = false;
      }

      // Validate fields only if no missing fields
      if (isValid) {
        keyFields.forEach((field, i) => {
          const value = item[field];

          // Blank value check (skip for COD_Value and Receiver_Email)
          if (!value && field !== "COD_Value" && field !== "Receiver_Email") {
            rowError[i] = "BLANK VALUE";
            isValid = false;
          }

          // Validate specific fields
          if (
            field === "Receiver_Pincode" &&
            value &&
            value.length !== pincodeLength
          ) {
            rowError[i] = "INVALID PINCODE";
            isValid = false;
          }
          if (field === "Receiver_Mobile") {
            if (value && value.length !== mobileLength) {
              rowError[i] = "INVALID MOBILE LENGTH";
              isValid = false;
            } else if (value && isNaN(value)) {
              rowError[i] = "INVALID MOBILE FORMAT";
              isValid = false;
            }
          }
          if (
            field === "Receiver_Email" &&
            value &&
            !value.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)
          ) {
            rowError[i] = "INVALID EMAIL";
            isValid = false;
          }
          if (
            field === "COD_Value" &&
            (!value || isNaN(value)) &&
            item["Payment_Mode"]?.toLowerCase() === "cod"
          ) {
            rowError[i] = "COD VALUE REQUIRED";
            isValid = false;
          }
        });
      }

      // Add row errors if invalid
      if (!isValid) {
        csvError.push({
          rowIndex: index + 1,
          errors: rowError,
        });
        validFile = false;
      }
    });

    if (validFile) {
      setUploadModalState({ excel_fle: file, show: false });
      setloader(false);
    } else {
      setloader(false);
      // Format errors for toast display
      const errorMessages = csvError
        .map(({ rowIndex, errors }) =>
          errors
            .map((error, colIndex) =>
              error
                ? `Row ${rowIndex} Column ${keyFields[colIndex]}: ${error}`
                : ""
            )
            .filter(Boolean)
        )
        .flat();

      const Toast = Swal.mixin({
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 3000,
      });
      errorMessages.forEach((message) => {
        Toast.fire({
          background: "#ff0000",
          icon: "error",
          title: message,
          color: "white",
        });
      });
      //
    }
  };
  const uploadOrdersFile = () => {
    setLoadingstate(true);
    if (
      uploadModalState.excel_fle != undefined &&
      uploadModalState.excel_fle != ""
    ) {
      // var patt1 = /\.([0-9a-z]+)(?:[\?#]|$)/i;
      let fileName = uploadModalState.excel_fle[0].name;
      // // console.log("fileName =======>                 ",fileName);

      // // console.log("file =======>                 ",fileName.match(/\.([0-9a-z]+)(?:[\?#]|$)/i)[0]);
      // return
      if (fileName.match(/\.([0-9a-z]+)(?:[\?#]|$)/i)[0] == ".csv") {
        Papa.parse(uploadModalState.excel_fle[0], {
          complete: (result) => {
            const dataLength = result.data.length;
            // console.log("dataLength == " , dataLength)

            if (dataLength <= 1001) {
              let full_api = config.apiUrl + `/shipment/upload_bulk_orders`;
              let bodyFormData = new FormData();
              // // console.log("bb", editState);

              bodyFormData.append("customer_id", userData.customer_id);

              bodyFormData.append("excel_fle", uploadModalState.excel_fle[0]);

              // let bodyData = {country_id:country_id,csvFile:uploadModalState.csv_fle}
              // console.log("bb", bodyFormData);
              let header = config.headers;
              header.Accept = "text/event-stream";
              console.log(header);
              axios({
                method: "post",
                url: full_api,
                headers: header,
                data: bodyFormData,
                // responseType: "stream",
                // onDownloadProgress: progressEvent => {
                //    console.log("progressEvent ", progressEvent.currentTarget.response);
                //   let json = progressEvent.currentTarget.response.split("Z");
                //   json = JSON.parse(json[json.length - 1]);
                //   // console.log(json)
                //   if (json.status != "pending") {

                //     // console.log(v)

                //     Toast.fire({
                //       background: "#206bc4",
                //       type: 'success',
                //       title: "Bulk Import Finished",
                //       color: "white"
                //     });
                //     shipment_list()
                //     setLoadingstate(false)
                //     setSummarystate(true)
                //     setRecordid({ record_id: json.data })
                //     setUploadState({ ...uploadState, status: "" })

                //   } else {
                //     // console.log(json.data);
                //     let v = json.data.split("S");
                //     v = v[v.length - 1];
                //     setUploadState({ ...uploadState, status: v })
                //     setRecordid({ record_id: json.record_id })
                //   }

                // }
              })
                .then((res) => {
                  console.log("res ", res);

                  // setUploadModalState({...uploadModalState, show: false });
                  //  setEditState({ ...editState, state_name: "", state_id: "" })

                  if (res.status == 200) {
                    if (res.data.status == "success") {
                      setLoadingstate(false);
                      setSummarystate(true);
                      setRecordid({ record_id: res.data.record_id });

                      Toast.fire({
                        background: "#206bc4",
                        type: "success",
                        title: "Bulk Order Import Process Started",
                        color: "white",
                      });
                      setTimeout(() => {
                        window.location.replace(
                          `/bulk_order_log_detail?id=${res.data.record_id}`
                        );
                      }, 1000);
                      shipment_list();
                      // setTimeout(getStateList(0,true), 5000);
                    } else {
                      //setUploadState(res.data)
                    }

                    // shipment_list()
                    // setTimeout(()=>{
                    //   navigate(`/import_process/${product_id}/${carrier_id}/${source_city_id}`)
                    // },1000)
                  } else {
                    console.log("res unsuccess");
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Something went wrong!",
                    });
                  }

                  // navigate('/categories')
                  // let newCategory = res.data.category;
                  //setState(state.concat([newCategory]))
                })
                .catch((e) => {
                  console.log("error  ", e);
                  // Swal.fire({
                  //   icon: 'error',
                  //   title: 'Oops...',
                  //   text: 'catch Something went wrong!',

                  // })
                });
            } else {
              setLoadingstate(false);
              setSummarystate(false);
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Not Allowed to Import more than 1000 orders in one file ",
              });
            }
          },
        });
      } else {
        const Toast = Swal.mixin({
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 3000,
        });
        Toast.fire({
          background: "#206bc4",
          type: "error",
          title: "Please choose CSV file!",
          color: "white",
        });
        setLoadingstate(false);
      }
    } else {
      // const Toast = Swal.mixin({
      //   toast: true,
      //   position: 'bottom-end',
      //   showConfirmButton: false,
      //   timer: 3000
      // })
      // Toast.fire({
      //   background: "#206bc4",
      //   type: 'error',
      //   title: "Please choose a file!",
      //   color: "white"
      // });
      setLoadingstate(false);
    }
  };
  React.useEffect(() => {
    uploadOrdersFile();
  }, [uploadModalState.excel_fle]);

  return (
    <div>
      <Header>
        <div className="content">
          {/* <!-- ═══════════ PAGE HEADER ═══════════ --> */}
          <div class="ol-header">
            <div class="ol-hd">
              <a
                type="button"
                class="ol-back"
                id="olCoBack"
                title="Go back"
                href="javascript:window.history.back();"
              >
                <i class="bi bi-arrow-left"></i>
              </a>
              <div>
                <div class="ol-title">Create Order</div>
                <div class="ol-sub">
                  Create a single order or upload orders in bulk
                </div>
              </div>
            </div>
          </div>

          {/* <!-- ═══════════ SINGLE / BULK SWITCH ═══════════ --> */}
          <div class="ol-co-tabs" role="tablist">
            <button
              type="button"
              className={`ol-co-tab ${orderView === "single" ? "on" : ""}`}
              role="tab"
              aria-selected={orderView === "single"}
              onClick={() => {
                setOrderView("single");
                setSearchParams({});
              }}
            >
              <i class="bi bi-box2"></i> Single Order
            </button>
            <button
              type="button"
              className={`ol-co-tab ${orderView === "bulk" ? "on" : ""}`}
              role="tab"
              aria-selected={orderView === "bulk"}
              onClick={() => {
                setOrderView("bulk");
                setSearchParams({ view: "bulk" });
              }}
            >
              <i class="bi bi-cloud-arrow-up"></i> Bulk Order
            </button>
          </div>

          {/* <!-- ═══════════ SINGLE ORDER ═══════════ --> */}
          {orderView === "single" && (
            <div class="ol-co-view" data-co-view="single">
              <div class="ol-co-grid">
                <div class="ol-co-main">
                  {/* <!-- Order Type --> */}
                  <div class="card-base ol-co-card">
                    <div class="ol-co-head">
                      <i class="bi bi-tag"></i> Order Type
                    </div>
                    <div class="ol-co-body">
                      <div class="ol-co-grid3">
                        {/* <div class="ol-field">
                        <label>
                          Type <span class="ol-req">*</span>
                        </label>
                        <div class="ol-seg ol-co-type" id="coTypeSeg">
                          <button
                            type="button"
                            className={`on ${
                              orderDetails.parcel_type === "Parcel" ? "on" : ""
                            }`}
                            data-co-type="parcel"
                            onClick={() =>
                              setOrderDetails({
                                ...orderDetails,
                                parcel_type: "Parcel",
                              })
                            }
                          >
                            <i className="bi bi-box"></i> Parcel
                          </button>
                          <button
                            type="button"
                            className={
                              orderDetails.parcel_type === "Documents"
                                ? "on"
                                : ""
                            }
                            data-co-type="document"
                            onClick={() =>
                              setOrderDetails({
                                ...orderDetails,
                                parcel_type: "Documents",
                              })
                            }
                          >
                            <i className="bi bi-file-earmark-text"></i>{" "}
                            Documents
                          </button>
                        </div>
                      </div> */}
                        <div class="ol-field">
                          <label>Order ID</label>
                          <input
                            type="text"
                            value={orderDetails.order_id}
                            disabled
                            placeholder="Leave blank for auto generate"
                            autocomplete="off"
                          />
                        </div>
                        <div class="ol-field">
                          <label>Order Date</label>
                          <input
                            type="date"
                            value={orderDetails.order_date}
                            onChange={(e) =>
                              setOrderDetails({
                                ...orderDetails,
                                order_date: e.target.value,
                              })
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <!-- Pickup Address --> */}
                  <div class="card-base ol-co-card">
                    <div class="ol-co-head">
                      <i class="bi bi-geo-alt"></i> Pickup Address
                    </div>
                    <div class="ol-co-body">
                      <div class="ol-field">
                        <label>
                          Warehouse <span class="ol-req">*</span>
                        </label>
                        <select
                          // id="coWarehouse"
                          value={
                            selectedAddress !== null ? selectedAddress : ""
                          }
                          onChange={(e) =>
                            setSelectedAddress(parseInt(e.target.value))
                          }
                        >
                          <option value="">Select a warehouse</option>
                          {addressList.map((addr, idx) => (
                            <option key={idx} value={idx}>
                              {addr.warehouse_name || addr.full_name} -{" "}
                              {addr.city_name}, {addr.pincode}
                            </option>
                          ))}
                        </select>
                      </div>

                      {selectedAddress !== null &&
                        addressList[selectedAddress] && (
                          <div className="ol-co-wh-preview" id="coWhPreview">
                            <div className="card p-2">
                              <strong>
                                {addressList[selectedAddress].warehouse_id}
                              </strong>
                              <small>
                                {addressList[selectedAddress].address},{" "}
                                {addressList[selectedAddress].city_name},{" "}
                                {addressList[selectedAddress].state_name},{" "}
                                {addressList[selectedAddress].pincode}
                              </small>
                              <small>
                                {" "}
                                {addressList[selectedAddress].mobile}
                              </small>
                            </div>
                          </div>
                        )}

                      <button type="button" class="ol-co-wh-add" id="coWhAdd">
                        <i class="bi bi-plus-lg"></i> Add New Warehouse
                      </button>
                    </div>
                  </div>

                  {/* <!-- Buyer's Details --> */}
                  <div class="card-base ol-co-card">
                    <div class="ol-co-head">
                      <i class="bi bi-person"></i> Buyer's Details
                    </div>
                    <div class="ol-co-body">
                      <div class="ol-co-grid2">
                        <div class="ol-field">
                          <label>
                            Mobile <span class="ol-req">*</span>
                          </label>
                          <input
                            type="tel"
                            id="coMobile"
                            placeholder="Enter buyer's mobile number"
                            maxLength="10"
                            autoComplete="off"
                            value={receiver.receiver_mobile}
                            onChange={(e) =>
                              setReceiver({
                                ...receiver,
                                receiver_mobile: e.target.value,
                              })
                            }
                          />
                          {receiver.receiver_mobile &&
                            receiver.receiver_mobile.length !== 10 && (
                              <small className="text-danger">
                                Enter 10 digits
                              </small>
                            )}
                        </div>
                        <div class="ol-field">
                          <label>
                            Full Name <span class="ol-req">*</span>
                          </label>
                          <input
                            type="text"
                            id="coName"
                            placeholder="Enter full name"
                            autoComplete="off"
                            value={receiver.receiver_name}
                            onChange={(e) =>
                              setReceiver({
                                ...receiver,
                                receiver_name: e.target.value,
                              })
                            }
                          />
                        </div>
                        <div class="ol-field">
                          <label>Email</label>
                          <input
                            type="email"
                            id="coEmail"
                            placeholder="Enter email id"
                            autoComplete="off"
                            value={receiver.receiver_email}
                            onChange={(e) =>
                              setReceiver({
                                ...receiver,
                                receiver_email: e.target.value,
                              })
                            }
                          />
                        </div>
                        <div class="ol-field">
                          <label>
                            Address <span class="ol-req">*</span>
                          </label>
                          <input
                            type="text"
                            id="coAddress"
                            placeholder="Enter complete address"
                            autoComplete="off"
                            value={receiver.receiver_address}
                            onChange={(e) =>
                              setReceiver({
                                ...receiver,
                                receiver_address: e.target.value,
                              })
                            }
                          />
                        </div>
                      </div>
                      <div class="ol-co-grid3">
                        <div class="ol-field">
                          <label>
                            Pincode <span class="ol-req">*</span>
                          </label>
                          <input
                            type="tel"
                            id="coPincode"
                            placeholder="Enter pincode"
                            maxLength="6"
                            autoComplete="off"
                            value={pincodeInput}
                            onChange={handlePincodeChange}
                          />
                        </div>
                        <div class="ol-field">
                          <label>
                            State <span class="ol-req">*</span>
                          </label>
                          {receiver.mode === "Domestic" ? (
                            <input
                              type="text"
                              // className="form-control"
                              value={autoState}
                              disabled
                            />
                          ) : (
                            <select
                              id="coState"
                              value={
                                receiver.receiver_state_id
                                  ? `${receiver.receiver_state_id},${
                                      selectedCountryId || ""
                                    }`
                                  : ""
                              }
                              onChange={handleStateChange}
                            >
                              <option value="">Select State</option>
                              {stateList.map((s) => (
                                <option
                                  key={s.state_id}
                                  value={`${s.state_id},${s.country_id}`}
                                >
                                  {s.state_name}
                                </option>
                              ))}
                            </select>
                          )}
                        </div>
                        <div class="ol-field">
                          <label>
                            City <span class="ol-req">*</span>
                          </label>
                          {receiver.mode === "Domestic" ? (
                            <input
                              type="text"
                              // className="form-control"
                              value={autoCity}
                              disabled
                            />
                          ) : (
                            <select
                              id="coCity"
                              value={receiver.receiver_city_id}
                              onChange={handleCityChange}
                            >
                              <option value="">Select City</option>
                              {cityList.map((c) => (
                                <option key={c.city_id} value={c.city_id}>
                                  {c.city_name}
                                </option>
                              ))}
                            </select>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="ol-co-side">
                  {/* <!-- Product Details --> */}
                  <div class="card-base ol-co-card">
                    <div class="ol-co-head">
                      <i class="bi bi-box-seam"></i> Product Details
                      <button
                        type="button"
                        class="ol-co-add"
                        id="coAddProduct"
                        onClick={addProductRow}
                      >
                        <i class="bi bi-plus-lg"></i> Add Item
                      </button>
                    </div>
                    <div className="ol-co-body" id="coProducts">
                      {/* <div class="ol-prod-row" data-i="' + i + '">' +
      '<div class="ol-prod-field"><label>Product Name</label><input type="text" class="co-prod-name" placeholder="Enter product name" autocomplete="off" /></div>' +
      '<div class="ol-prod-field"><label>SKU</label><input type="text" class="co-prod-sku" placeholder="SKU" autocomplete="off" /></div>' +
      '<div class="ol-prod-field"><label>Qty</label><input type="number" class="co-prod-qty" value="1" min="1" step="1" /></div>' +
      '<div class="ol-prod-field"><label>Unit Price (₹)</label><input type="number" class="co-prod-price" value="0" min="0" step="0.01" /></div>' +
      '<button type="button" class="ol-prod-del" title="Remove item"><i class="bi bi-x-lg"></i></button>' +
      '</div> */}
                      {products.map((p, idx) => (
                        <div key={idx} className="ol-prod-row">
                          <div className="ol-prod-field">
                            <label>Product Name</label>
                            <input
                              type="text"
                              className="co-prod-name"
                              placeholder="Enter product name"
                              value={p.shipment_content}
                              onChange={(e) =>
                                updateProduct(
                                  idx,
                                  "shipment_content",
                                  e.target.value
                                )
                              }
                            />
                          </div>
                          <div className="ol-prod-field">
                            <label>SKU</label>
                            <input
                              type="text"
                              className="co-prod-sku"
                              placeholder="SKU"
                              value={p.item_sku}
                              onChange={(e) =>
                                updateProduct(idx, "item_sku", e.target.value)
                              }
                            />
                          </div>
                          <div className="ol-prod-field">
                            <label>Qty</label>
                            <input
                              type="number"
                              className="co-prod-price"
                              placeholder="Qty"
                              min="1"
                              value={p.quantity}
                              onChange={(e) =>
                                updateProduct(idx, "quantity", e.target.value)
                              }
                            />
                          </div>
                          <div className="ol-prod-field">
                            <label>Unit Price (₹)</label>
                            <input
                              type="number"
                              className="co-prod-price"
                              placeholder="0.00"
                              step="0.01"
                              min="0"
                              value={p.total_value}
                              onChange={(e) =>
                                updateProduct(
                                  idx,
                                  "total_value",
                                  e.target.value
                                )
                              }
                            />
                          </div>

                          {idx === products.length - 1 ? (
                            <button
                              type="button"
                              className="ol-prod-del"
                              onClick={addProductRow}
                            >
                              <i className="bi bi-plus"></i>
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="ol-prod-del"
                              onClick={() => removeProductRow(idx)}
                            >
                              <i className="bi bi-dash"></i>
                            </button>
                          )}
                        </div>
                      ))}
                    </div>

                    <div class="ol-co-foot">
                      <span>Sub Total</span>
                      <b id="coSubTotal">₹ {calculateTotal().toFixed(2)}</b>
                    </div>
                  </div>

                  {/* <!-- Payment --> */}
                  <div class="card-base ol-co-card">
                    <div class="ol-co-head">
                      <i class="bi bi-credit-card"></i> Payment
                    </div>
                    <div class="ol-co-body">
                      <div class="ol-seg ol-co-pay" id="coPaySeg">
                        <button
                          type="button"
                          className={
                            orderDetails.payment_mode === "prepaid" ? "on" : ""
                          }
                          data-co-pay="prepaid"
                          onClick={() =>
                            setOrderDetails({
                              ...orderDetails,
                              payment_mode: "prepaid",
                              cod_amount: "",
                            })
                          }
                        >
                          <i className="bi bi-bank"></i> Prepaid
                        </button>

                        <button
                          type="button"
                          className={
                            orderDetails.payment_mode === "cod" ? "on" : ""
                          }
                          data-co-pay="cod"
                          onClick={() =>
                            setOrderDetails({
                              ...orderDetails,
                              payment_mode: "cod",
                            })
                          }
                        >
                          <i className="bi bi-cash-coin"></i> COD
                        </button>
                      </div>
                      {orderDetails.payment_mode === "cod" && (
                        <div
                          className="ol-field ol-co-codfield"
                          id="coCodField"
                        >
                          <label>
                            COD Amount <span className="ol-req">*</span>
                          </label>
                          <div className="ol-input-affix ol-affix-left">
                            <span>₹</span>
                            <input
                              type="number"
                              id="coCodAmt"
                              placeholder="0.00"
                              min="0"
                              step="0.01"
                              value={orderDetails.cod_amount}
                              onChange={(e) =>
                                setOrderDetails({
                                  ...orderDetails,
                                  cod_amount: e.target.value,
                                })
                              }
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* <!-- Weight & Dimensions --> */}
                  <div class="card-base ol-co-card">
                    <div class="ol-co-head">
                      <i class="bi bi-box"></i> Weight &amp; Dimensions
                    </div>
                    <div class="ol-co-body">
                      <div class="ol-co-grid2">
                        <div class="ol-field">
                          <label>
                            Dead Weight <span class="ol-req">*</span>
                          </label>
                          <div class="ol-input-affix">
                            <input
                              type="number"
                              id="coDeadWt"
                              placeholder="0.00"
                              min="0"
                              step="0.01"
                              value={packageData.dead_weight}
                              onChange={(e) =>
                                setPackageData({
                                  ...packageData,
                                  dead_weight: e.target.value,
                                })
                              }
                            />
                            <span>KG</span>
                          </div>
                        </div>
                        <div class="ol-field">
                          <label>Length</label>
                          <div class="ol-input-affix">
                            <input
                              type="number"
                              id="coLen"
                              placeholder="0"
                              min="0"
                              step="0.1"
                              value={packageData.length}
                              onChange={(e) =>
                                setPackageData({
                                  ...packageData,
                                  length: e.target.value,
                                })
                              }
                            />
                            <span>cm</span>
                          </div>
                        </div>
                        <div class="ol-field">
                          <label>Width</label>
                          <div class="ol-input-affix">
                            <input
                              type="number"
                              id="coWid"
                              placeholder="0"
                              min="0"
                              step="0.1"
                              value={packageData.width}
                              onChange={(e) =>
                                setPackageData({
                                  ...packageData,
                                  width: e.target.value,
                                })
                              }
                            />
                            <span>cm</span>
                          </div>
                        </div>
                        <div class="ol-field">
                          <label>Height</label>
                          <div class="ol-input-affix">
                            <input
                              type="number"
                              id="coHei"
                              placeholder="0"
                              min="0"
                              step="0.1"
                              value={packageData.height}
                              onChange={(e) =>
                                setPackageData({
                                  ...packageData,
                                  height: e.target.value,
                                })
                              }
                            />
                            <span>cm</span>
                          </div>
                        </div>
                      </div>
                      <div class="ol-co-calc">
                        <div class="ol-co-calc-row">
                          <span>Dead Weight</span>
                          <b id="coCalcDead">
                            {" "}
                            {(parseFloat(packageData.dead_weight) || 0).toFixed(
                              2
                            )}{" "}
                            kg
                          </b>
                        </div>
                        <div class="ol-co-calc-row">
                          <span>Vol. Weight</span>
                          <b id="coCalcVol">{volumetricWeight.toFixed(2)} kg</b>
                        </div>
                        <div class="ol-co-calc-row strong">
                          <span>Applicable</span>
                          <b id="coCalcApp">
                            {applicableWeight().toFixed(2)} kg
                          </b>
                        </div>
                        <div class="ol-co-calc-row total">
                          <span>Order Value</span>
                          <b id="coCalcVal">₹ {calculateTotal().toFixed(2)}</b>
                        </div>
                      </div>
                      <small class="ol-hint-tx">
                        Applicable weight is the heavier of Dead Weight and
                        Volumetric Weight (L × W × H ÷ 5000).
                      </small>
                    </div>
                  </div>

                  <button
                    type="button"
                    className="ol-co-submit"
                    id="coCreateBtn"
                    onClick={handleSubmit}
                    disabled={submitting}
                  >
                    {submitting ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Creating...
                      </>
                    ) : (
                      <>
                        <i className="bi bi-send"></i> Create Order
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* <!-- ═══════════ BULK ORDER ═══════════ --> */}
          {orderView === "bulk" && (
            <div class="ol-co-view" data-co-view="bulk">
              <div class="ol-co-grid">
                <div class="ol-co-main">
                  <div class="card-base ol-co-card">
                    <div class="ol-co-head">
                      <i class="bi bi-cloud-arrow-up"></i> Upload Bulk Orders
                    </div>
                    <div class="ol-co-body">
                      <div class="ol-co-drop" id="coDrop">
                        <input
                          type="file"
                          id="coFile"
                          accept=".csv"
                          name="excel_fle"
                          onChange={(e) => csvinputEditHandleChange(e)}
                        />
                        <i class="bi bi-cloud-arrow-up"></i>
                        <b>Browse and Upload</b>
                        <small>
                          Drag &amp; drop your file here, or click to select
                        </small>
                        <em>
                          Only CSV files are acceptable · Use the sample
                          template
                        </em>
                      </div>
                      <div class="ol-co-upload-note">
                        <i class="bi bi-lightbulb"></i>
                        <div>
                          <b>How it works</b>
                          <p>
                            Download the sample file, replace its data with your
                            order data, fill all mandatory fields and upload it
                            back. Creating orders will take a few minutes and
                            runs in the background.
                          </p>
                        </div>
                        <a
                          // href="https://SkyShipcdn.fniix.com/sample-template/bulk-order-template.csv"
                          href="../../../assets/doc/DOMESTIC_BULK_ORDER_UPLOAD.csv"
                          target="_blank"
                          class="ol-btn"
                        >
                          <i class="bi bi-download"></i> Download Sample File
                        </a>
                      </div>
                    </div>
                  </div>

                  <div class="card-base ol-co-card">
                    <div class="ol-co-head">
                      <i class="bi bi-clock-history"></i> Recent Uploads
                    </div>
                    {dataloader ? (
                      <div style={{ marginLeft: "50%", alignItems: "center" }}>
                        <ReactLoading
                          type={"spin"}
                          color={"#0d6efd"}
                          height={40}
                          width={40}
                        />
                      </div>
                    ) : (
                      <div class="ol-co-body ol-co-table-wrap">
                        <table class="ol-co-table">
                          <thead>
                            <tr>
                              <th>File Name</th>
                              <th>Date</th>
                              <th>No. Of Orders</th>
                              <th>Uploaded Orders</th>

                              <th>Log</th>
                            </tr>
                          </thead>
                          {summaryloader ? (
                            <ReactLoading
                              type={"spin"}
                              color={"#0d6efd"}
                              height={40}
                              width={40}
                            />
                          ) : (
                            <tbody>
                              {statesummary.map((sub) => (
                                <tr>
                                  <td>
                                    <a
                                      href={`/bulk_order_log_detail?id=${
                                        recordid.record_id
                                          ? recordid.record_id
                                          : sub.record_id
                                      }`}
                                    >
                                      {sub.file_name.length > 15 ? (
                                        <>
                                          {sub.file_name.slice(0, 15)}
                                          <br />
                                          {sub.file_name.slice(15)}
                                        </>
                                      ) : (
                                        sub.file_name
                                      )}
                                    </a>
                                  </td>
                                  <td>
                                    <Moment format="MMM DD YYYY">
                                      {new Date(sub.start_time * 1000)}
                                    </Moment>{" "}
                                    -{" "}
                                    <Moment format="hh:mm:ss a">
                                      {new Date(sub.start_time * 1000)}
                                    </Moment>
                                  </td>
                                  <td>{sub.total_record}</td>
                                  <td>
                                    <span class="ol-co-stat ok">
                                      {sub.uploaded_record}
                                    </span>
                                  </td>

                                  <td>
                                    <a
                                      href={`/bulk_order_log_detail?id=${
                                        recordid.record_id
                                          ? recordid.record_id
                                          : sub.record_id
                                      }`}
                                    >
                                      Import log{" "}
                                      <i class="bi bi-arrow-right"></i>
                                    </a>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          )}
                        </table>
                      </div>
                    )}
                  </div>
                </div>

                <div class="ol-co-side">
                  <div class="card-base ol-co-card ol-co-side-hero">
                    <div class="ol-bulk-hero">
                      <div class="ol-bulk-scene">
                        <div class="ol-bulk-ring"></div>
                        <div class="ol-bulk-cloud">
                          <i class="bi bi-cloud-arrow-up-fill"></i>
                        </div>
                        <div class="ol-bulk-packets">
                          <span class="ol-bulk-pkt q1"></span>
                          <span class="ol-bulk-pkt q2"></span>
                          <span class="ol-bulk-pkt q3"></span>
                        </div>
                      </div>
                      <h3>Bulk ordering made simple</h3>
                      <p>
                        Upload hundreds of orders in a single CSV and let
                        SkyShip create them in the background.
                      </p>
                    </div>
                  </div>

                  <div class="card-base ol-co-card">
                    <div class="ol-co-head">
                      <i class="bi bi-signpost-split"></i> How it works
                    </div>
                    <div class="ol-co-body ol-co-steps">
                      <div class="ol-co-step">
                        <span class="ol-co-step-n">1</span>
                        <div>
                          <b>Download the template</b>
                          <p>
                            Get the sample CSV with all the mandatory columns
                            pre-filled.
                          </p>
                        </div>
                      </div>
                      <div class="ol-co-step">
                        <span class="ol-co-step-n">2</span>
                        <div>
                          <b>Fill in your orders</b>
                          <p>
                            Paste your order data. Keep the column order
                            unchanged.
                          </p>
                        </div>
                      </div>
                      <div class="ol-co-step">
                        <span class="ol-co-step-n">3</span>
                        <div>
                          <b>Upload the CSV</b>
                          <p>
                            Drag &amp; drop the file here or browse from your
                            device.
                          </p>
                        </div>
                      </div>
                      <div class="ol-co-step">
                        <span class="ol-co-step-n">4</span>
                        <div>
                          <b>We create them for you</b>
                          <p>
                            Orders are processed in the background. Track
                            progress in Recent Uploads.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="card-base ol-co-card">
                    <div class="ol-co-head">
                      <i class="bi bi-check2-square"></i> Before you upload
                    </div>
                    <div class="ol-co-body ol-co-checks">
                      <div class="ol-co-check">
                        <i class="bi bi-check-circle-fill"></i> File must be a{" "}
                        <b>.csv</b> (not Excel)
                      </div>
                      <div class="ol-co-check">
                        <i class="bi bi-check-circle-fill"></i> Keep the{" "}
                        <b>header row</b> and column order
                      </div>
                      <div class="ol-co-check">
                        <i class="bi bi-check-circle-fill"></i> Fill all{" "}
                        <b>mandatory fields</b> marked with *
                      </div>
                      <div class="ol-co-check">
                        <i class="bi bi-check-circle-fill"></i> Valid{" "}
                        <b>6-digit pincodes</b> and <b>10-digit mobiles</b>
                      </div>
                      <div class="ol-co-check">
                        <i class="bi bi-check-circle-fill"></i> Rows with errors
                        are skipped &amp; reported in the log
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div
            class="modal fade ol-bulk-modal"
            id="coWhModal"
            tabindex="-1"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-header">
                  <div>
                    <h5 class="modal-title">
                      <i class="bi bi-buildings"></i> Add New Warehouse
                    </h5>
                    <p class="ol-bulk-sub">
                      The new warehouse will be available as a pickup address
                    </p>
                  </div>
                  <button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div class="modal-body">
                  <div class="ol-co-grid2">
                    <div class="ol-field">
                      <label>
                        Warehouse Name <span class="ol-req">*</span>
                      </label>
                      <input
                        type="text"
                        id="coWhName"
                        placeholder="e.g. WH-79909007"
                        autocomplete="off"
                      />
                    </div>
                    <div class="ol-field">
                      <label>
                        Sender Full Name <span class="ol-req">*</span>
                      </label>
                      <input
                        type="text"
                        id="coWhSender"
                        placeholder="Enter sender's full name"
                        autocomplete="off"
                      />
                    </div>
                    <div class="ol-field">
                      <label>
                        Pincode <span class="ol-req">*</span>
                      </label>
                      <input
                        type="tel"
                        id="coWhPin"
                        placeholder="Enter pincode"
                        maxlength="6"
                        autocomplete="off"
                      />
                    </div>
                    <div class="ol-field">
                      <label>
                        City <span class="ol-req">*</span>
                      </label>
                      <select id="coWhCity" disabled>
                        <option value="">Select City</option>
                      </select>
                    </div>
                    <div class="ol-field">
                      <label>
                        State <span class="ol-req">*</span>
                      </label>
                      <select id="coWhState">
                        <option value="">Select State</option>
                        <option>Haryana</option>
                        <option>Delhi</option>
                        <option>Maharashtra</option>
                        <option>Karnataka</option>
                        <option>Tamil Nadu</option>
                      </select>
                    </div>
                    <div class="ol-field">
                      <label>Email</label>
                      <input
                        type="email"
                        id="coWhEmail"
                        placeholder="Enter email"
                        autocomplete="off"
                      />
                    </div>
                    <div class="ol-field ol-co-wh-full">
                      <label>
                        Address <span class="ol-req">*</span>
                      </label>
                      <input
                        type="text"
                        id="coWhAddr"
                        placeholder="Enter complete address"
                        autocomplete="off"
                      />
                    </div>
                    <div class="ol-field">
                      <label>
                        Mobile No <span class="ol-req">*</span>
                      </label>
                      <input
                        type="tel"
                        id="coWhPhone"
                        placeholder="Enter mobile number"
                        maxlength="10"
                        autocomplete="off"
                      />
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-light"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button type="button" class="btn btn-primary" id="coWhSave">
                    <i class="bi bi-check2"></i> Save &amp; Select
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Header>
      <Footer />
    </div>
  );
};

export default Create_order;
